import { DownloadIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { Spinner } from '@/components/ui/spinner';

import type { ConversationDownload } from '../../hooks/useDownloadConversation';

type Props = { download: ConversationDownload };

export const DownloadConversationItem = ({ download }: Props) => {
  const { t } = useTranslation();

  return (
    <DropdownMenuItem
      disabled={!download.canDownload || download.isDownloading}
      onSelect={(event) => {
        event.preventDefault();
        download.start();
      }}
    >
      {download.isDownloading ? (
        <Spinner className="text-foreground-muted" />
      ) : (
        <DownloadIcon size={16} className="text-foreground-muted" />
      )}
      {t('try_it.download_as_pdf')}
    </DropdownMenuItem>
  );
};
